import { GppBad as GppBadIcon, Security as SecurityIcon } from "../../_core/components/icons";
import { UITooltip } from "../../_core/components";

export interface MfaIconProps {
  isEnabled: boolean;
}

const MfaIcon = ({ isEnabled }: MfaIconProps) => {
  return (
    <UITooltip title={isEnabled ? "MFA Enabled" : "MFA Disabled"}>
      {isEnabled ? (
        <SecurityIcon color="success" />
      ) : (
        <GppBadIcon color="disabled" />
      )}
    </UITooltip>
  );
};

export default MfaIcon;